import React from "react";
import Footer from "../../components/Footer_/Footer";
import Reviews from "../../components/Reviews_/Reviews";
import AboutSec from "../../components/AboutSec_/AboutSec";
import WhyChooseUs from "../../components/WhyChooseUs_/WhyChooseUs";
import Vision from "../../components/Vision_/Vision";
import CommonHero from "../../components/CommonHero_/CommonHero";
import CategoriesRow from "../../components/CategoriesRow_/CategoriesRow";
import CallToAction from "../../components/CallToAction/CallToAction";
import { Helmet } from "react-helmet";
import Header from "../../components/Header_/Header";

const AboutScreen = () => {
  return (
    <>
      <Helmet>
        <title>About TRU Off Grid | Solar and Battery Installers in Milton, ON</title>
        <meta name="keywords" content="Batteries in Ontario" />
        <link rel="canonical" href="https://www.truoffgrid.com/about" />
        <meta
          name="description"
          content="Solar and battery storage installers in Milton, Ontario. EG4 and EP Cube 2.0 home batteries, off-grid systems and commercial site power. Book your free consultation today!"
        />
      </Helmet>
      {/* <CommonHero
        // image={"/images/hero-about.jpg"}
        heading="ABOUT US"
      /> */}
      <Header />
      <AboutSec
        heading={"ABOUT TRU OFF GRID"}
        subHeading={"Our Story"}
        text={`TRU Off Grid is a growing, family owned business located in the heart of Milton, Ontario
        serving renewable & sustainable Energy Solutions across Canada. We offer a broad and unique range of Lithium (LiFePO4) applications, PV solar systems and home
battery storage. Our competitive advantage is personal and knowledgeable customer service, free
        consultation and due to low overhead and operating costs, we offer the best pricing in the industry.
        We go beyond transactions and work to develop long term relationships with our customers. Our
        mission is simple but profound: "Powering Life Anywhere." TRU Off Grid aims to make a meaningful
        impact on reducing emissions by harnessing the power of clean energy sources.`}
        img={"/images/about.webp"}
      />
      <CallToAction cta2={true} />
      <AboutSec
        heading={"Our Founder"}
        text={`TRU Off Grid was founded by Jack Abrams in 2019 and he is the Head of
        Sales, Customer Solutions and Leads Installation Projects. Jack grew up as
        an avid outdoorsman and completed a Business Degree at University of
        Guelph, Ontario with a minor in Entrepreneurial Studies. Jack has a passion
        for protecting the environment with clean and green energy solutions. Jack
        and our team have installed over 650 kW of Solar Power and we are the
        largest dealer for ECOFLOW products in Ontario.`}
        img={"/images/about2.png"}
        reverse={true}
      />
      <AboutSec
        heading={"The TRU Off Grid team at our Milton shop, 348 Bronte St S."}
        text={``}
        img={"/images/about3.jpg"}
        reverse={false}
        imgBorderRad={true}
      />
      <CategoriesRow />
      <AboutSec
        subHeading={"Milton, ON"}
        heading={"The TRU Shop"}
        text={`The TRU Off Grid shop and warehouse is at <a href="https://www.google.com/maps/search/348+Bronte+St+S,+Unit+21?entry=gmail&source=g" target="blank">348 Bronte St S, Unit 21 in Milton.</a> Come see EG4, EP Cube 2.0 and EcoFlow systems in person, talk through your project with our team, and pick up in-stock batteries, panels, power stations and parts. Visits are by appointment, so please call or email at least 3 hours ahead. We are open Monday to Friday, 9 am to 5 pm. Call <a href="tel:905-462-6525">905-462-6525</a> or email <a href="mailto:sales@truoffgrid.com">sales@truoffgrid.com</a> to book a time.`}
        reverse={true}
        // img={"/images/video2.png"}
        // imgLink={"https://www.youtube.com/watch?v=htcdoUEYJF0"}
        img={"/images/video.jpeg"}
        imgLink={"https://www.youtube.com/shorts/SniSJxlrnMQ"}
        backgroundGradient={"linear-gradient(to left, #fff, #fff, #bf2e1b3c)"}
      />

       <AboutSec
        heading={"In stock at our Milton shop. Pickup by appointment."}
        text={``}
        img={"/images/about4.jpg"}
        reverse={false}
        imgBorderRad={true}
      />
      {/* <WhyChooseUs />
      <Vision />
      <Statistics /> */}
      <Reviews />
      <Footer newsletter={true} />
    </>
  );
};

export default AboutScreen;
